export const cardOneTransactionHistoryMockData = [
  {
    id: 17,
    name: "Movie Tickets",
    details: "Jennifer Adams",
    amount: 30.0,
    info: "debit",
    timestamp: "2023-09-14T20:15:00Z",
    type: 1,
  },
  {
    id: 18,
    name: "Medical Expenses",
    details: "Daniel Carter",
    amount: 85.5,
    info: "debit",
    timestamp: "2023-09-14T12:45:30Z",
    type: 0,
  },
  {
    id: 19,
    name: "Online Course Fee",
    details: "Grace Taylor",
    amount: 120.0,
    info: "credit",
    timestamp: "2023-09-13T09:30:15Z",
    type: 2,
  },
  {
    id: 20,
    name: "Home Decor",
    details: "Ryan Mitchell",
    amount: 75.99,
    info: "debit",
    timestamp: "2023-09-13T14:20:45Z",
    type: 1,
  },
  {
    id: 21,
    name: "Utility Bill",
    details: "Megan Turner",
    amount: 50.0,
    info: "debit",
    timestamp: "2023-09-12T18:10:00Z",
    type: 2,
  },
  {
    id: 22,
    name: "Online Gaming Subscription",
    details: "William Brown",
    amount: 10.0,
    info: "credit",
    timestamp: "2023-09-12T22:30:30Z",
    type: 0,
  },
  {
    id: 23,
    name: "Tech Gadgets Purchase",
    details: "Sophie Evans",
    amount: 299.0,
    info: "debit",
    timestamp: "2023-09-11T11:45:15Z",
    type: 1,
  },
  {
    id: 24,
    name: "Music Concert Tickets",
    details: "Liam Smith",
    amount: 60.5,
    info: "debit",
    timestamp: "2023-09-11T19:20:00Z",
    type: 0,
  },
  {
    id: 25,
    name: "Credit Card Payment",
    details: "Ella Jones",
    amount: 150.0,
    info: "credit",
    timestamp: "2023-09-10T14:55:45Z",
    type: 2,
  },
  {
    id: 26,
    name: "Fitness Apparel",
    details: "Noah Davis",
    amount: 45.99,
    info: "debit",
    timestamp: "2023-09-10T16:30:30Z",
    type: 1,
  },
];
